import React, { useEffect, useState,useRef  } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import bannerImg from '../../images/about-banner.jpg';
import about from '../../images/24k1.jpg';
import strenght from '../../images/about-2.jpg';
import { Navbar } from './Navbar';
import '../../css/aboutus.css';
import icon1 from '../../images/builder-icon/63bd16a7ae537logo2.png';
import icon2 from '../../images/builder-icon/65117cc691ae0.jpg';
import icon3 from '../../images/builder-icon/169444832_105064958360639_228820477096437103_n.png';
import icon4 from '../../images/builder-icon/a8ca5c016cd2facba8936f746917d226.png';
import icon5 from '../../images/builder-icon/avenye-one-logo.png';
import icon6 from '../../images/builder-icon/brigade-icon.png';
import icon7 from '../../images/builder-icon/brigade.png';
import icon8 from '../../images/builder-icon/cropped-Steppsstone-Logo-1 (1).png';
import icon9 from '../../images/builder-icon/developerlogo.png';
import icon10 from '../../images/builder-icon/DLF_logo.svg.png';
import icon11 from '../../images/builder-icon/dra-trinity-logos.png';
import icon12 from '../../images/builder-icon/Elephantine-Colour-logo.png';

const reviews = [
  {
    name: 'lakshmikandh m',
    text: `Thank you Sachin for all your support, encouragement, and guidance. Thank you for being patient with me as I explored different projects. I truly appreciate your patient support while I explored different projects. Your insights were invaluable and helped me a lot to make my decision. I hope you continue your excellent work.`,
  },
  {
    name: 'Cedric Joseph',
    text: `It was a wonderful meeting with the dynamic team of passionate real estate consultants at 24k realtors, when we met them on the 29th of December.
Led by the dynamic Mariappan who gave us a very good insight on how to look for the most appropriate investment opportunity and the rest of the team (the meeting was coordinated by Senba), it was a very good team offering excellent choices, options and are patient.
I would certainly recommend 24k.`,
  },
  {
    name: 'mohan raj',
    text: `Very good service and information given was very detailed. Mariyppan Sir guided me through out the house buying journey. Saved me lot of time in my busy schedule. Thank you for your kind approach Mariappan Sir.`,
  },
  {
    name: 'Balakumaran A',
    text: `We had an opportunity to associate with 24K Realtors. I was contacted on the phone by Pavithra, who sent the details of the properties and coordinated with site visit. Mr. Kundan Kumar showed us the property and had an understanding in what our expectation was. Though we were not able to proceed. We would definitely would associate with 24K in future`,
  },
  {
    name: 'Manithan Bharathi',
    text: `It was an amazing experience with 24K realtors. They have provided me various options based on my requirements and satisfied my needs. Kudos to the team and thanks for the support.
Special thanks and regards to Ms. Prasilla and Mr. Suresh who made my property visit very convenient and was very helpful throughout the process. The information shared by them are very genuine with on-time response.
`,
  },

  // Add more reviews here
];




const logos = [icon1,icon2,icon3,icon4,icon5,icon6,icon7,icon8,icon9,icon10,icon11,icon12]

function AboutPage() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 5000); // change every 5 seconds
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollRef.current && !isPaused) {
        scrollRef.current.scrollBy({ left: 1, behavior: 'smooth' });
        if (
          scrollRef.current.scrollLeft + scrollRef.current.offsetWidth >=
          scrollRef.current.scrollWidth
        ) {
          scrollRef.current.scrollLeft = 0;
        }
      }
    }, 20); // lower = smoother and continuous

    return () => clearInterval(interval);
  }, [isPaused]);


  return (
    <div>
      <Helmet>
        <title>About Us - Top Real Estate Agents In Chennai | 24Krealtors</title>
        <meta
          name="description"
          content="Discover the top real estate agents in Chennai with 24K Realtors. Expert guidance, premium properties, and exceptional service for all your real estate needs."
        />
      </Helmet>
      <Navbar />

      <main className="about-modern colorful-layout">
        {/* Hero Section */}
        <section className="hero1">
          <img src={bannerImg} alt="About Banner" className="hero-img" />
          <div className="hero-overlay1">
            <motion.h1 initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
              About Us
            </motion.h1>
                     </div>
        </section>

        {/* Intro Section */}
        <section className="section-color-block block-white">
          <div className="content-split">
            <div className="text-side">
              <h2> About Us – From the Founder’s Desk</h2>
              <h3>Welcome to 24K Realtors,</h3>
              <h4> I’m Mariyappan, Founder of 24K Realtors.</h4>
              <p>24K Realtors is Chennai No.1 REAL ESTATE Sales and Marketing based company. We are helping people to find a new Home with out any Service Charge. Having good market knowledge and good negotiations will help your property search. We deal only Grade A developer project, where the legal(Title) crystal clear projects</p>
            </div>
            <div className="img-side">
              <img src={about} alt="Mission Graphic" />
            </div>
          </div>
        </section>

        <section className="review-section">
  <h4>Google Reviews</h4>
  <h2>From Our Customers</h2>
  <div className="review-card fade-in">
    <div className="stars">
      <span>★ ★ ★ ★ ★</span>
    </div>
    <p>{reviews[current].text}</p>
    <h5>{reviews[current].name}</h5>
  </div>
</section>



    <section className="partner-section">
      <h2>Our Partners</h2>
      <p>We are honoured to have these amazing partners.</p>
      <div
        className="carousel"
        ref={scrollRef}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {[...logos, ...logos].map((logo, index) => (
          <img key={index} src={logo} alt="Partner Logo" className="partner-logo" />
        ))}
      </div>
    </section>


        {/* 
        <section className="section-color-block1 block-blue-img">
          <div className='leftside'>
          <h2> Our Strength</h2><p>It’s a platform that empowers local real estate consultants — whom we proudly call Pincode Entrepreneurs — and gives them the tools, training, and structure to succeed in their own territories.
              <br /><br />At its core, Pincode Pillars is built on local expertise, professional integrity, and long-term trust. We offer complete real estate services — from resale, rentals, leasing, and PGs to investment deals — with clarity, support, and a personal touch.
              </p>
              </div>
          <div className="pill-grid1">
            <div className="pill-card1">A dedicated expert in your pincode</div>
            <div className="pill-card1">Zero brokerage on all transactions</div>
            <div className="pill-card1">Verified property listings</div>
            <div className="pill-card1"><img alt='' src={strenght} /></div>
            <div className="pill-card1">Full support from start to finish</div>
            <div className="pill-card1">CRM, documentation & deal tracking</div>
          </div>
        </section>

{/* 
      
        <section className="section-color-block block-white">
          <div className="content-split reverse">
            <div className="img-side">
              <img src={chooseImg} alt="Why Us" />
            </div>
            <div className="text-side">
              <h2>🎯 Our Mission</h2>
              <p>To deliver transparent, zero-brokerage real estate consulting across every Indian pincode, with local experts who understand customer needs and provide end-to-end support.</p>

              <h2>👁️ Our Vision</h2>
              <p>To become the top real estate platform in India, led by 1,000+ Pincode Entrepreneurs, trusted by families, investors, and businesses in every corner of the country.</p>
            </div>
          </div>
        </section>

 
        <section className="section-color-block block-yellow">
          <h2>💡 Our Values</h2>
          <div className="pill-grid">
            <div className="pill-card">Transparency in every transaction</div>
            <div className="pill-card">Local trust with national standards</div>
            <div className="pill-card">Ethical and compliant operations</div>
            <div className="pill-card">Future-ready technology</div>
            <div className="pill-card">Customer-first, always</div>
          </div>
        </section>

        <section className="section-color-block block-pink">
          <h2>🙌 Why Choose Pincode Pillars?</h2>
          <div className="pill-grid">
            <div className="pill-card">Dedicated local experts</div>
            <div className="pill-card">Zero-brokerage model</div>
            <div className="pill-card">Updated, verified listings</div>
            <div className="pill-card">Home loans, legal, registration</div>
            <div className="pill-card">After-sale & on-call support</div>
            <div className="pill-card">Resale, rental, lease, PG</div>
            <div className="pill-card">CRM tracking & status updates</div>
            <div className="pill-card">Transparency and long-term trust</div>
          </div>
        </section> */}
      </main>
    </div>
  );
}

export default AboutPage;